export default "__VITE_ASSET__f8c52e46__"